/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReferenceModelList {
    getFixupPrototypeFunction() { return ReferenceModelList.fixupPrototype; }

    static newInstance(model: Partial<ReferenceModelList>): ReferenceModelList {
        let obj = Object.assign(new ReferenceModelList(), model);
        ReferenceModelList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReferenceModelList>): ReferenceModelList {
        if (!model) return null;
        return ReferenceModelList.newInstance(<ReferenceModelList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReferenceModelList) {
        if (!obj) return;

        models.ReferenceModelList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReferenceModelList): boolean {
        Object.setPrototypeOf(obj, ReferenceModelList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Visible
     */
    visible: boolean;

}
